import { apiUpload } from '@/shared/api/client';
import type { ApiResponse } from '@/shared/types/api.types';

async function uploadFile(endpoint: string, file: File): Promise<string> {
  const formData = new FormData();
  formData.append('file', file);

  const result = await apiUpload<ApiResponse<{ url: string }>>(endpoint, formData);
  return result.data.url;
}

export const logoService = {
  async uploadLogo(companyId: string, file: File): Promise<string> {
    return uploadFile(`/companies/${companyId}/logo`, file);
  },

  async uploadDarkLogo(companyId: string, file: File): Promise<string> {
    return uploadFile(`/companies/${companyId}/dark-logo`, file);
  },
};
